import script from "./QuickpaySettingsProviderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickpaySettingsProviderCard.vue?vue&type=script&setup=true&lang=js"

import "./QuickpaySettingsProviderCard.vue?vue&type=style&index=0&id=3c4430d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4430d4"]])

export default __exports__